// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"9811dbc7","387":"2430804f","453":"f8273fb6","480":"b1cab51f","708":"f8f7020b","859":"e1bfc692","888":"d60416aa","946":"5d780e23"}[chunkId] + ".chunk.js";
};